import {
    type DeclineMatchingResponse,
    type PartnerEngagementSummary,
    type PostContactRequest,
    type PostedContactRequest,
    declineMatchingResponseSchema,
    partnerEngagementSummarySchema,
    postedContactRequestSchema,
} from '@houzy/schemas/partner-cockpit/partner-matching';

import { apiRequest } from '../../../lib/api';
import { partnerCockpitApiPath } from '../../../lib/config';

export async function fetchMatchingEngagement(
    matchingUuid: string,
    signal?: AbortSignal,
): Promise<PartnerEngagementSummary | null> {
    return apiRequest(partnerCockpitApiPath(`matchings/${matchingUuid}/engagement`), {
        signal,
        responseSchema: partnerEngagementSummarySchema.nullable(),
    });
}

export async function postContactRequest(
    matchingUuid: string,
    payload: PostContactRequest,
): Promise<PostedContactRequest> {
    return apiRequest(partnerCockpitApiPath(`matchings/${matchingUuid}/contact-request`), {
        method: 'POST',
        body: payload,
        responseSchema: postedContactRequestSchema,
    });
}

export async function postDeclineMatching(matchingUuid: string): Promise<DeclineMatchingResponse> {
    return apiRequest(partnerCockpitApiPath(`matchings/${matchingUuid}/decline`), {
        method: 'POST',
        responseSchema: declineMatchingResponseSchema,
    });
}
